import { useState } from "react";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import { NavLink } from "react-router-dom";
import SEO from "../SEO";
import { db } from "../../firebase";

export default function HaContact() {
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const [honeypot, setHoneypot] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [lastSubmit, setLastSubmit] = useState(0);

  const set = (k) => (e) => setForm((p) => ({ ...p, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (honeypot) return;
    const now = Date.now();
    if (now - lastSubmit < 60_000) return;
    setBusy(true);
    try {
      await addDoc(collection(db, "ha_contact"), { ...form, createdAt: serverTimestamp() });
      setDone(true);
      setLastSubmit(now);
    } catch (err) {
      console.error(err);
    }
    setBusy(false);
  };

  return (
    <div className="ha-legal">
      <SEO title="Support – Heat.ai" description="Contact the Heat.ai support team." path="/heatai/contact" />
      <h1>Contact Support</h1>
      <p className="ha-meta">We usually respond within 24 hours.</p>

      {done ? (
        <p style={{ color: "#34d399", fontWeight: 600 }}>✅ Message sent! We'll be in touch shortly.</p>
      ) : (
        <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <input name="website" style={{ display: "none" }} value={honeypot} onChange={(e) => setHoneypot(e.target.value)} />
          {[
            { label: "Name", key: "name", type: "text", placeholder: "Your name" },
            { label: "Email", key: "email", type: "email", placeholder: "your@email.com" },
            { label: "Subject", key: "subject", type: "text", placeholder: "What's this about?" },
          ].map(({ label, key, type, placeholder }) => (
            <div key={key}>
              <label style={{ display: "block", fontSize: 13, color: "rgba(255,255,255,0.55)", marginBottom: 6 }}>{label}</label>
              <input
                type={type}
                placeholder={placeholder}
                value={form[key]}
                onChange={set(key)}
                required
                style={{ width: "100%", padding: "12px 16px", borderRadius: 10, border: "1px solid rgba(255,255,255,0.1)", background: "#111", color: "#fff", fontSize: "0.95rem", outline: "none" }}
              />
            </div>
          ))}
          <div>
            <label style={{ display: "block", fontSize: 13, color: "rgba(255,255,255,0.55)", marginBottom: 6 }}>Message</label>
            <textarea
              rows={5}
              placeholder="Tell us how we can help…"
              value={form.message}
              onChange={set("message")}
              required
              style={{ width: "100%", padding: "12px 16px", borderRadius: 10, border: "1px solid rgba(255,255,255,0.1)", background: "#111", color: "#fff", fontSize: "0.95rem", resize: "vertical", outline: "none" }}
            />
          </div>
          <button type="submit" className="ha-btn ha-btn-primary" style={{ alignSelf: "flex-start" }} disabled={busy}>
            {busy ? "Sending…" : "Send Message"}
          </button>
        </form>
      )}

      <div className="ha-contact-block" style={{ marginTop: 40 }}>
        <p><strong>Email:</strong> <a href="mailto:support@macromatrix.io">support@macromatrix.io</a></p>
        <p><strong>Company:</strong> MacroMatrix (Pvt) Limited</p>
        <p><strong>Lahore:</strong> Office No 4-A-I Commercial Area, PGEHS, Lahore, Pakistan</p>
        <p><strong>Dubai:</strong> 7th Floor, Opal Tower, 701–705, BJK Blvd, Business Bay, Dubai – UAE</p>
      </div>

      <p style={{ marginTop: 24 }}>
        <NavLink to="/heatai/faq" style={{ color: "#ff2d55" }}>← Browse the FAQ</NavLink>
      </p>
    </div>
  );
}
